import { createMailReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsMail';
import { getCurrentDateTime } from '../DateTime';
import { SportsType } from '../enums/SportsType';
import { MailerSendMailObject } from '../interface/mailInterface/MailerSendMailInterface';
import { isValidString } from '../Validity';
import { getNCRMembershipMailText, NCRMembership } from '../NCR';

export const createSignUpButtonPressedMailObject = (
    mailId: string,
    teamName: string,
    organizationName: string,
    sportsType: SportsType,
    ncrMembership: NCRMembership,
    referralId: string,
    email: string,
): MailerSendMailObject => {
    return {
        id: mailId,
        reference: createMailReference(mailId),
        teamId: '',
        teamReference: null,
        from: { email: 'admin@optimxsports.com', name: 'OptimX Sports' },
        to: [{ email: 'contact@optimxtechnologies.com', name: 'OptimX Sports' }],
        cc: [],
        bcc: [],
        reply_to: {},
        subject: createSignUpButtonPressedMailSubject(teamName, email, ncrMembership, referralId),
        html: createSignUpButtonPressedMailText(teamName, organizationName, email, ncrMembership, referralId),
        text: createSignUpButtonPressedMailText(teamName, organizationName, email, ncrMembership, referralId),
        template_id: '',
        variables: [],
        personalization: [],
        tags: ['signup', 'signup_button'],
        sportsType,
        timeModified: getCurrentDateTime(),
        timeCreated: getCurrentDateTime(),
    };
};

const createSignUpButtonPressedMailText = (
    teamName: string,
    organizationName: string,
    email: string,
    ncrMembership: NCRMembership,
    referralId: string,
) => {
    return `Signup Button Pressed --- Team Name is: ${teamName}. Organization Name is: ${organizationName}. Email is: ${email}.${getNCRMembershipMailText(ncrMembership)} Referral Id: ${referralId}`;
};

const createSignUpButtonPressedMailSubject = (teamName: string, email: string, ncrMembership: NCRMembership, referralId: string) => {
    const ncrPrefix = ncrMembership === NCRMembership.NCR ? 'NCR TEAM - ' : '';
    if (isValidString(referralId)) {
        return `${ncrPrefix}SIGNUP BUTTON PRESSED FROM ${teamName} USING EMAIL: ${email} THROUGH: ${referralId}`;
    }
    return `${ncrPrefix}SIGNUP BUTTON PRESSED FROM ${teamName} USING EMAIL: ${email}`;
};
